import React from 'react';
import GradientText from './base/GradientText';
import ImageView from './base/ImageView';
import { FONTS } from '../constants/Fonts';

/** Figma 18423:3802 — type pill (SINGER / ACTOR / …) */
const EntityTypeBadge = ({ label }) => {
    if (!label) return null;
    return (
        <div
            data-node-id="18423:3802"
            style={{
                position: 'relative',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 12px',
                borderRadius: 100,
                overflow: 'hidden',
                flexShrink: 0,
            }}
        >
            <span
                aria-hidden
                style={{
                    position: 'absolute',
                    inset: 0,
                    background: '#4d3400',
                    borderRadius: 100,
                    pointerEvents: 'none',
                }}
            />
            <span
                data-node-id="18423:3803"
                style={{
                    position: 'relative',
                    zIndex: 1,
                    fontFamily: FONTS.INTER_BOLD,
                    fontWeight: 700,
                    fontSize: 20,
                    lineHeight: '32px',
                    letterSpacing: 0.8,
                    color: '#ffd700',
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    whiteSpace: 'nowrap',
                }}
            >
                {label}
            </span>
            <span
                aria-hidden
                style={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 100,
                    boxShadow: 'inset 0px 4px 4px 0px rgba(0,0,0,0.25)',
                    pointerEvents: 'none',
                }}
            />
        </div>
    );
};

const RapHousieEntityTriviaCard = ({
    triviaData = {},
    onClick,
    variant = 'default',
}) => {
    const entity = triviaData?.entity;
    const image = triviaData?.profileImage || triviaData?.image || entity?.entity?.url || entity?.image;
    const name = triviaData?.name || entity?.title || entity?.entity?.displayName;
    const category = triviaData?.category || entity?.category?.name || entity?.entity?.type || '';
    const categoryColor = entity?.category?.color || '';
    const description = entity?.data || [];
    const statistics = triviaData?.statistics || [];
    const isLiveCompact = variant === 'live';

    return (
        <div
            data-node-id={isLiveCompact ? '18423:3796' : undefined}
            style={{
                flex: 1,
                flexDirection: 'column',
                height: isLiveCompact ? 'auto' : '100%',
                width: '100%',
                display: 'flex',
                justifyContent: 'start',
                alignItems: 'center',
                margin: '0 auto',
                borderRadius: isLiveCompact ? 0 : 24,
                overflow: 'hidden',
                color: isLiveCompact ? '#003' : '#fff',
                fontFamily: isLiveCompact ? FONTS.INTER_SEMIBOLD : FONTS.MONTSERRAT_SEMIBOLD,
                gap: isLiveCompact ? 20 : 0,
            }}
            onClick={() => onClick && onClick(triviaData)}
        >
            <div
                data-node-id={isLiveCompact ? '18423:3797' : undefined}
                style={{
                    position: 'relative',
                    height: isLiveCompact ? 189 : 240,
                    width: isLiveCompact ? 189 : '100%',
                    borderRadius: 24,
                    overflow: 'hidden',
                    flexShrink: 0,
                    border: isLiveCompact ? '2px solid #ffffff' : 'none',
                    boxSizing: 'border-box',
                }}
            >
                <ImageView
                    src={image}
                    alt={name}
                    width="100%"
                    height="100%"
                    objectFit="cover"
                />
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        borderRadius: 24,
                        background: 'linear-gradient(to bottom, rgba(0,0,0,0), #000000)',
                        pointerEvents: 'none',
                    }}
                />
            </div>

            <div
                style={{
                    padding: isLiveCompact ? 0 : 20,
                    width: '100%',
                    maxWidth: isLiveCompact ? 337 : 'none',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: isLiveCompact ? 14 : 0,
                }}
            >
                {isLiveCompact ? (
                    <>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 10,
                                width: '100%',
                                maxWidth: 298,
                            }}
                        >
                            <div
                                data-node-id="18423:3801"
                                style={{
                                    fontFamily: FONTS.INTER_MEDIUM,
                                    fontWeight: 500,
                                    fontSize: 24,
                                    lineHeight: '32px',
                                    letterSpacing: 0.8,
                                    color: '#003',
                                    textAlign: 'center',
                                    width: '100%',
                                    wordBreak: 'break-word',
                                }}
                            >
                                {name}
                            </div>
                            <EntityTypeBadge label={category} />
                        </div>
                        <div
                            data-node-id="18423:3804"
                            style={{
                                width: '100%',
                                height: 1,
                                background: 'rgba(0, 0, 51, 0.2)',
                                flexShrink: 0,
                            }}
                        />
                    </>
                ) : (
                    <>
                        <div
                            style={{
                                color: categoryColor || '#FFC107',
                                fontSize: 14,
                                fontWeight: 700,
                                letterSpacing: 3,
                                marginBottom: 8,
                                fontFamily: FONTS.MONTSERRAT_BOLD,
                                textTransform: 'uppercase',
                            }}
                        >
                            {category.toUpperCase()}
                        </div>
                        <GradientText
                            text={name}
                            fontSize={20}
                            fontWeight={700}
                            fontFamily={FONTS.MONTSERRAT_BOLD}
                            gradientColor1="#FFFFFF"
                            gradientColor2="#FFFFFF99"
                        />
                        <div
                            style={{
                                height: 4,
                                backgroundColor: '#2F2F2F',
                                margin: '16px 0',
                            }}
                        />
                    </>
                )}

                {description?.map((item, index) => (
                    <div
                        key={`${item.label}-${index}`}
                        style={{ width: '100%' }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                gap: 16,
                                padding: isLiveCompact ? 0 : '10px 0',
                            }}
                        >
                            <div
                                style={{
                                    color: isLiveCompact ? '#003' : '#BDBDBD',
                                    opacity: isLiveCompact ? 0.5 : 1,
                                    fontSize: isLiveCompact ? 16 : 14,
                                    fontWeight: isLiveCompact ? 600 : 400,
                                    lineHeight: isLiveCompact ? '24px' : '20px',
                                    letterSpacing: 0.8,
                                    fontFamily: isLiveCompact
                                        ? FONTS.INTER_SEMIBOLD
                                        : FONTS.MONTSERRAT_SEMIBOLD,
                                    minWidth: isLiveCompact ? 0 : 100,
                                    flexShrink: 0,
                                }}
                            >
                                {item.label}
                            </div>
                            <div
                                style={{
                                    fontSize: isLiveCompact ? 16 : 14,
                                    fontWeight: 600,
                                    lineHeight: isLiveCompact ? '24px' : '20px',
                                    letterSpacing: 0.8,
                                    fontFamily: isLiveCompact
                                        ? FONTS.INTER_SEMIBOLD
                                        : FONTS.MONTSERRAT_SEMIBOLD,
                                    textAlign: 'right',
                                    color: isLiveCompact ? '#003' : '#FFFFFF',
                                    flex: 1,
                                    whiteSpace: isLiveCompact ? 'normal' : 'nowrap',
                                    wordBreak: 'break-word',
                                }}
                            >
                                {item.text || '-'}
                            </div>
                        </div>
                        {!isLiveCompact && index !== description.length - 1 && (
                            <div
                                style={{
                                    height: 1.5,
                                    background:
                                        'repeating-linear-gradient(90deg,#333 0,#333 4px,transparent 4px,transparent 8px)',
                                }}
                            />
                        )}
                    </div>
                ))}
            </div>

            {!isLiveCompact && statistics?.length > 0 && (
                <div
                    style={{
                        margin: 16,
                        padding: 16,
                        backgroundColor: '#2F2F2F',
                        borderRadius: 20,
                        width: '100%',
                        boxSizing: 'border-box',
                    }}
                >
                    <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>
                        Statistics{' '}
                        <span style={{ color: '#A0A0A0', fontWeight: 400 }}>
                            (Production house&apos;s last 3 films)
                        </span>
                    </div>
                    {statistics.map((item, index) => (
                        <div key={`${item.title}-${index}`}>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    padding: '12px 0',
                                    fontSize: 16,
                                }}
                            >
                                <span style={{ color: '#CFCFCF' }}>{item.title}</span>
                                <span style={{ fontWeight: 600 }}>{item.value}</span>
                            </div>
                            {index !== statistics.length - 1 && (
                                <div style={{ height: 1, backgroundColor: '#3E3E3E' }} />
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RapHousieEntityTriviaCard;
